import React from "react";
import EmptyStateLayout from "../../shared/EmptyStateLayout";
import BalanceTable from "./BalanceTable";
import { CalendarDays, NoPoints, withBalanceContainer } from "../../normalizer";
import { NavLink, withRouter } from "react-router-dom";
import { t } from "../../../../i18n";
import CustomLink from "../../shared/CustomLink";
import CustomButton from "../../shared/CustomButton";

const Table = (props) => {
  const { client, campaign, points, onClickUserProduction, ...rest } = props;

  return points.length > 0 ? (
    <div className="balance-container">
      <BalanceTable points={points} {...rest} />
      {client.slug == "vodafone" ? (
        <div className="row justify-between items-center">
          <span className="col-xs-12 col-sm-12">
            {t("gamification2026.profile.detailed-view-click")}
            <CustomLink
              onClick={onClickUserProduction}
              className="g-footer--contacts-link"
            >
              {" "}
              {t("gamification2026.profile.here")}
            </CustomLink>
          </span>
        </div>
      ) : (
        <></>
      )}
    </div>
  ) : (
    <EmptyStateLayout message={t("gamification2026.profile.earn-points-tip")}>
      <div className="flex dead-grey flex-col justify-center items-center mt-5 mb-10">
        <NoPoints className="mr-3 dead-grey gl-no-store__image mb-5" />
        <h2>{t("gamification2026.profile.no-points")}</h2>
      </div>
    </EmptyStateLayout>
  );
};
const Balance = (props) => {
  const { history } = props;
  return (
    <div>
      <div>
        <CustomButton
          secondary
          onClick={() => history.push("/profile/balance/history")}
        >
          <CalendarDays />
          Ver histórico-tabela
        </CustomButton>
      </div>
      <Table {...props}></Table>
    </div>
  );
};

export default withBalanceContainer(withRouter(Balance));
